import { HttpErrorResponse } from "@angular/common/http";
import { ENV_CONSTANTS } from "@env-properties/environment";
import { TAGGING_ERRORS } from "../constants/TaggingErrors";

export class AddHashTagImplementation{
    public universalService:any;
    public http:any;
    public router:any;
    static singleInstance:AddHashTagImplementation;
    public enableButton:boolean = false;
    public hashTagError:any = {"msg":"","type":""};
    public newTagsList:any= [];
    public currentTagName:any = "";
    public existingTagsList:any=[];
    public recentsTagsList:any= [];
    public maxLimitError:boolean = false;
    public removedTagsList:any;
    public selectedObject:any;
    public initialTagsCountObject:number;
    public listService:any;
    public alphaNumericRegex = /^[a-zA-Z0-9]+$/ // only alphanumeric characters
    public numbersRegex = /^[0-9]+$/;
    cleverTapEventsService: any;
    showTagAutoSuggestion: boolean = false;

    constructor(globalService){

    }

    public static getInstance(globalService):AddHashTagImplementation{
        if(this.singleInstance == null){
            this.singleInstance = new AddHashTagImplementation(globalService);
        }
        return this.singleInstance;
    }

    setHandler(globalService){
        this.universalService = globalService.getUniversalServiceRef();
        this.http = globalService.getHttpClientRef();
        this.router = globalService.getRouterRef();
        this.listService = globalService.getListServiceRef();
        this.cleverTapEventsService =  globalService.getCleverTapEventsvc();

    }

    getRecentTags(url){
        var classRef = this;
		return new Promise(function(resolve, reject){
			classRef.http.get(url).subscribe(
				(suc) => { 
				
					resolve(suc);
				},
				(error:HttpErrorResponse) => { 
					reject(error)
				},
			);
		})
    }
    setPayloadForUpdatingTags(newAdded,removedTags){
        var tagArray = [];
        newAdded.map(tag=>{
            tagArray.push({
                "tag":tag,
                "operation":"A"
            })
        })
        removedTags.map(tag=>{
            tagArray.push({
                "tagKey":tag["tagKey"],
                "operation":"R"
            })
        })
        return tagArray;
    }



    updateHashTags(url,payload,newTags,recentsTagsList,tagCount){
         payload = {
            "objectKey":this.selectedObject["objectKey"],
            "tags":payload
        }
        var self = this;
        return new Promise(function(resolve,reject){
            self.http.put(url,payload).subscribe(
                suc=>{
                    let recentCount=0
                    for (var val of newTags) {
                        var recentTagIndex = recentsTagsList.findIndex(recentTag => recentTag.tag == val);
                        if(recentTagIndex!=-1){
                            recentCount++; 
                        }
                    }
                    self.universalService.showLoader = false;
                    self.cleverTapEventsService.saveManualTag(tagCount,recentCount)

                    resolve(suc)
                },
                err=>{
                    console.log("error in updating tags list",err);
                    self.checkErrorStatus(err,"update");
                    reject(err);
                }
            )
        })
    }

    getHashTagsForTheObject(url){
       var self = this;
       return new Promise(function(resolve,reject){
           self.http.get(url).subscribe(
               suc=>{
                   self.fetchTagsForObject(suc);
                   resolve(suc)
               },
               err=>{
                   console.log("error in updating tags list",err);
                   self.checkErrorStatus(err,"fetch")
                   reject(err);
               }
           )
       })
   }

   fetchTagsForObject(tags){
       this.universalService.showLoader = false;
       this.existingTagsList = tags;
       this.initialTagsCountObject = tags.length;
       if(this.existingTagsList.length == ENV_CONSTANTS["constants"]["maxTagLimit"]){
           this.maxLimitError = true;
           this.setErrorMsg(TAGGING_ERRORS["MAX_LIMIT_REACHED"],true)
       }else{
        this.maxLimitError = false;
       }
   }

//    validations


/*
1. handle on click space
2. handle on click enter
3. >30 characters auto add
4. max 10 tags
5. paste the string
*/

    validateTag(tag){
        this.enableButton = false;
        var tag = this.currentTagName.trim();
        if(tag.length == 0){
            this.clearInputField();
            this.resetErrorDefaultMsg();
            return
        }
        if(tag.match(this.alphaNumericRegex)){
            if(tag.length != 0 && tag.length<3){
                this.setErrorMsg(TAGGING_ERRORS["MIN_LENGTH_ERROR"],true)
                this.enableButton = false;
            }else if(tag.match(this.numbersRegex)){
                this.setErrorMsg(TAGGING_ERRORS["ALPHA_NUMERIC_ERROR"],true)
                if(tag.length>30){
                    tag = tag.substring(0,30);
                    $(".inpt-tags").val(tag)
                }
                this.enableButton = false;
                return
            }else if((tag.charAt(0)).match(this.numbersRegex)){
                this.setErrorMsg(TAGGING_ERRORS["FIRST_CHARACTER_ERROR"],true);
                if(tag.length>30){
                    tag = tag.substring(0,30);
                    $(".inpt-tags").val(tag)
                }
                this.enableButton = false;
                return
            }else if(tag.length > 0 && tag.length <= 30){
                this.resetErrorDefaultMsg();
                this.enableButton = true;
            }else if(tag.length>30){
                tag = tag.substring(0,30);
                $(".inpt-tags").val(tag)
                this.enableButton = true;
                this.addTagToObject(tag)
                this.clearInputField();
            }
        }else if(!tag.match(this.alphaNumericRegex)){
            this.setErrorMsg(TAGGING_ERRORS["INVALID_TAG"],true);
            this.enableButton = false;
            if(tag.length>30){
                tag = tag.substring(0,30);
                $(".inpt-tags").val(tag)
            }else if(tag.length != 0 && tag.length<3){
                this.setErrorMsg(TAGGING_ERRORS["MIN_LENGTH_ERROR"],true)
                this.enableButton = false;
            }
            return;
        }
    }

    checkIfConditionsMetForAddingTheTag(tag){
        if(tag.length != 0 && tag.length<3){
            this.setErrorMsg(TAGGING_ERRORS["MIN_LENGTH_ERROR"],true)
            this.enableButton = false;
            this.currentTagName = '';
        }else if (tag.length != 0 && tag.match(this.numbersRegex)){
            this.setErrorMsg(TAGGING_ERRORS["ALPHA_NUMERIC_ERROR"],true)
            this.enableButton = false;
            this.currentTagName = '';
        }else if (this.newTagsList.length>0 || this.removedTagsList.length>0 || this.currentTagName != ""){
            this.enableButton = true;
        }
      }

    addTagToObject(tag){
        if(tag.length == 0){
            return
        }
        tag = "#" + tag;
        var newTagIndex = this.newTagsList.indexOf(tag);
        var existingTagIndex = this.existingTagsList.findIndex(existingTag => existingTag.tag == tag);
        var recentTagIndex = this.recentsTagsList.findIndex(recentTag => recentTag.tag == tag);
        var removedTag = this.removedTagsList.find(removedTag => removedTag.tag == tag);
        if(recentTagIndex>=0){
            this.recentsTagsList[recentTagIndex]["blurTag"] = true;
        }
        if((recentTagIndex >= 0 && (newTagIndex != -1 || existingTagIndex != -1)) || newTagIndex >= 0 || existingTagIndex >= 0){
            this.showTagAutoSuggestion = false;
            this.setErrorMsg(tag + TAGGING_ERRORS["TAG_ALREADY_EXISTS"],true);
            this.enableButton = false;
        }else if(removedTag){
            this.reAddRemovedTagBeforeSaving(removedTag)
        }else{
            this.updateNewTagsList(newTagIndex,existingTagIndex,tag);
        }        
    }
    
    addTagsFromRecent(tag){
        if(this.maxLimitError){
            this.setErrorMsg(TAGGING_ERRORS["MAX_LIMIT_REACHED"],true)
            this.checkIfEnableSaveButton();
            return
        }
        var newTagIndex = this.newTagsList.indexOf(tag);
        var existingTagIndex = this.existingTagsList.findIndex(existingTag => existingTag.tag == tag);
        var recentTagIndex = this.recentsTagsList.findIndex(recentTag=>recentTag["tag"] == tag)
        var removedTag = this.removedTagsList.find(removedTag => removedTag.tag == tag);
        if(newTagIndex >= 0  || existingTagIndex >=0){
            this.showTagAutoSuggestion = false;
            this.setErrorMsg(tag + TAGGING_ERRORS["TAG_ALREADY_EXISTS"],true);
            this.enableButton = false;
        }else if(removedTag){
            this.reAddRemovedTagBeforeSaving(removedTag)
        }else{
            var currentTag = this.currentTagName;
            this.updateNewTagsList(newTagIndex,existingTagIndex,tag);
            this.populateTheInputFieldAfterPerformingAction(currentTag);
        }
        this.recentsTagsList[recentTagIndex]["blurTag"] = true;
    }

    clearInputField(){ // clear input field after adding tag
        this.currentTagName = "";
        if(!this.maxLimitError)
        this.resetErrorDefaultMsg();
        setTimeout(() => {
            $('.inpt-tags').val('');
        });
        
      }

    checkIfMaxTagLimitIsReached(){
        if((this.newTagsList.length + this.existingTagsList.length) == ENV_CONSTANTS["constants"]["maxTagLimit"] ){
            this.maxLimitError = true;
            var newChangeMade = this.checkIfChangesMade()
            if(this.newTagsList.length > 0 || !newChangeMade){
                this.enableButton = true;
                this.setErrorMsg(TAGGING_ERRORS["MAX_LIMIT_REACHED"],true);
            }else{
                this.enableButton = false;
                this.resetErrorDefaultMsg();
            }
        }else{
            // if(!$('.inpt-tags').focus() && this.currentTagName != ""){
                this.resetErrorDefaultMsg();
            // }
            this.enableButton = true;
            this.maxLimitError = false;
            // this.focusOnInputField()
        }
        return this.enableButton;
    }

    updateNewTagsList(newTagIndex,existingTagIndex,tag){ // add the tag to new tags array
        this.checkIfMaxTagLimitIsReached();
        if(this.enableButton && newTagIndex == -1 && existingTagIndex == -1){
            this.newTagsList.push(tag);
            this.checkIfMaxTagLimitIsReached();
            this.checkIfEnableSaveButton();
            this.clearInputField();
            this.scrollToTag();
        }
    }

    reAddRemovedTagBeforeSaving(removedTag){ // this is when the user tried to remove a tag and adds it again before saving
        var removedIndex = this.removedTagsList.indexOf(removedTag)
        removedTag["reAddedSameTag"] = true;
        this.existingTagsList.push(removedTag);
        this.removedTagsList.splice(removedIndex,1);
        this.checkIfMaxTagLimitIsReached();
        this.clearInputField();
    }

    removeTag(tag){
        var newTagIndex = this.newTagsList.indexOf(tag);
        var existingTagIndex = this.existingTagsList.indexOf(tag);
        var recentTagIndex =  this.recentsTagsList.findIndex(recentTag => recentTag.tag == (tag["tag"]?tag["tag"]:tag));
        if(newTagIndex >= 0){
            this.newTagsList.splice(newTagIndex,1)
        }
        if(recentTagIndex >= 0){
            this.recentsTagsList[recentTagIndex]["blurTag"] = false;
        }
        if(existingTagIndex >= 0){
            this.existingTagsList.splice(existingTagIndex,1);
            tag["index"] = existingTagIndex
            this.removedTagsList.push(tag)
        }
        var currentTag = this.currentTagName;
        this.clearInputField()
        this.checkIfMaxTagLimitIsReached();
        this.populateTheInputFieldAfterPerformingAction(currentTag);
        this.checkIfEnableSaveButton();
    }

    focusOnInputField(){
        if(!this.universalService.show2FApopUp){
            setTimeout(() => {
                $('.inpt-tags').focus();
            }, 100);
        }    
        
    }

    checkErrorStatus(err,type){
        if(err["error"]["code"] == "NMSOM0138"){
            this.universalService.showToast(TAGGING_ERRORS["MAX_LIMIT_REACHED"],"error");
            this.maxLimitError = true;
        }else if (type == "update"){
            this.universalService.showToast(TAGGING_ERRORS["UPDATING_SERVER_ERROR"],"error");
            this.listService.deSelectAll();
        }else{
            this.universalService.showToast(TAGGING_ERRORS["SERVER_ERROR"],"error");
        }
    }

    resetErrorDefaultMsg(){
        // setTimeout(() => {
            this.hashTagError["msg"] = TAGGING_ERRORS["DEFAULT_TEXT"];
            this.hashTagError["type"] = "info";
        // }, 1);
        // $('.error').css({"color":"#2F2E33"})
        $('.inpt-tags').css({"color":"#2F2E33"})
    }

    setErrorMsg(err,changeColor){
        // setTimeout(() => {
            this.hashTagError["msg"] = err;
            this.hashTagError["type"] = "error";
        // }, 1);
        if(changeColor){
            // $('.error').css({"color":"#EB3224"})
            // setTimeout(() => {
                $('.inpt-tags').css({"color":"#EB3224"})
            // }, 1);
        }
    }

    checkIfEnableSaveButton(){
        if(this.newTagsList.length>0 || this.removedTagsList.length >0 || (this.initialTagsCountObject != this.existingTagsList.length)){
            this.enableButton = true;
        }else{
            this.enableButton = false;
        }
    }

    checkIfChangesMade(){
        var find = this.existingTagsList.find(tag=>tag["reAddedSameTag"] == true);
        if(this.newTagsList.length == 0 && this.removedTagsList.length == 0 && find){
          return false;
        }
        return true
      }

      objectPasted(tag){
        if(tag.length>30){
            this.setErrorMsg(TAGGING_ERRORS["LENGTH_ERROR"],true)
        }else if(!tag.match(this.alphaNumericRegex)){
            this.setErrorMsg(TAGGING_ERRORS["INVALID_TAG"],true)
        }else if((tag.charAt(0)).match(this.numbersRegex)){
            this.setErrorMsg(TAGGING_ERRORS["FIRST_CHARACTER_ERROR"],true);
        }else{
            var self = this;
            tag = (tag.length>30)?tag.substring(0,30):tag
            var character = tag.includes('#')?'#':(tag.includes(' ')?' ':'')
            if(tag.includes(character) && character != ''){
            var tags = tag.split(character);
            tags.map(function(tag){
                if(tag.match(self.alphaNumericRegex)){
                self.currentTagName = tag;
                
                self.validateTag(tag);
                if(self.enableButton){
                    self.checkIfConditionsMetForAddingTheTag(tag);
                    if(self.enableButton){
                        self.addTagToObject(tag)
                    }
                }
                }
            })
            setTimeout(() => {
                this.clearInputField();
                this.checkIfEnableSaveButton()
            });
            }else{
            if(tag.match(this.alphaNumericRegex)){
                this.currentTagName = tag
                this.validateTag(tag);
                if(this.enableButton){
                    this.checkIfConditionsMetForAddingTheTag(tag);
                    if(this.enableButton){
                        this.addTagToObject(tag)
                        if(this.enableButton){
                            setTimeout(() => {
                                this.clearInputField();
                                this.checkIfEnableSaveButton()
                                });
                        }
                        else{
                            this.currentTagName = "";
                        }
                    }
                }     
            }else{
                this.setErrorMsg(TAGGING_ERRORS["INVALID_TAG"],true)
            }
            }
        }
    }

      showNoInternetToast(){
          this.universalService.showToast(TAGGING_ERRORS["NO_INTERNET_MSG"],"error");
          this.setErrorMsg(TAGGING_ERRORS["NO_INTERNET_MSG"],true)
      }

      scrollToTag(){
          
        var objDiv = document.querySelector(".tags-scrollable");
        var tagsCont = document.querySelector(".tags-main") as any;
        setTimeout(() => {
            objDiv.scrollTop = (tagsCont.offsetHeight)/2 - 20;
        }, 10);
      }

      populateTheInputFieldAfterPerformingAction(currentTag){
        setTimeout(() => {
            $('.inpt-tags').val(currentTag);
            if(currentTag != ""){
            this.checkIfEnableSaveButton();
            this.setErrorMsg(TAGGING_ERRORS["BLUR_EVENT_ERROR"],true);
            }
        });
      }
}